module.exports = __webpack_public_path__ + "img/pcba_13.ac4aba66.png";